import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { handleScrollTo } from '../shared/scroll-to'

class SearchResultsController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
  }
  addEventListeners() {
    super.addEventListeners();
    document.documentElement.addEventListener("click", this.onDocClick);
  }
  removeEventListeners() {
    super.removeEventListeners();
    document.documentElement.removeEventListener("click", this.onDocClick);
  }
  /**
   * Own..
   */
  onDocClick = (e) => {
    if (e.target && e.target.classList.contains("search-form-switch")) {
      this.searchFormsSwitch(e);
    }
  }
  searchFormsSwitch = (e) => {
    e.preventDefault();
    const list = [...document.querySelectorAll(".box-search-form")];
    list.forEach(this.searchFormSwitch);
  }
  searchFormSwitch = (el, index) => {
    const trigger = el.querySelector(".search-mode-toggle:not(.active)");
    if (trigger) {
      trigger.click();
    }
  }


}

export default SearchResultsController;